import { Request } from '../main'
import Link from 'next/link'
import styles from './topnav.module.css'

const request = new Request(process.env.apiDomain)

function WStartNav(props) {
    const { data: wellness } = request.website.swrSite(props.site.accountId, "WC")
    //const wellness_url = wellness.url

    return (
        <>
            <div className="learn-and-earn">
                <div className="d-lg-block d-none">
                    <h5>Take the <strong>LEARN AND EARN</strong></h5>
                    <h6 className="mb-3"><small>Increase your wellness IQ <br className="d-lg-block d-none"/>
                        and earn $100 in free product <br className="d-lg-block d-none"/>
                        at retail price.</small></h6>
                    <img src="/images/dashboard/img-learn-and-earn01.svg" alt="Learn and Earn" className="d-block mx-auto mb-3" />
                    {wellness ? <a href={'/learn-and-earn/overview'} className="btn btn-green rounded-pill text-white px-4"><strong>START</strong></a> : null}
                </div>
                <div className="d-lg-none d-block px-3">
                    {wellness ? <Link href={'/learn-and-earn/overview'}><a className="d-flex align-items-center">
                        <img src="/images/dashboard/img-learn-and-earn01.svg" alt="Learn and Earn" width={35} className="mr-2"/>
                        <div>
                            <h6 className="mb-0">Take the <strong>LEARN AND EARN</strong></h6>
                            <small>Increase your wellness IQ and earn $100 in free product at retail price.</small>
                        </div>
                    </a></Link> : null}
                </div>
            </div>
        </>
    )
}

export default WStartNav
